<script>
import reportDataService from '../../services/reportDataService'
import ImageService from '../../services/imageService'
import { AbundanceMeter } from '../d3-components/index'
import TermButton from '../elements/TermButton'
import { abundanceModel } from '../../model/abundanceModel'
import Report from '../../model/report'
import commonFunctions from '../../mixins/commonFunctions'

export default {
  name: 'SpeciesOfInterestBase',
  components: {
    AbundanceMeter,
    TermButton
  },
  mixins: [commonFunctions],
  props: {
    speciesData: {
      type: Object,
      default: null,
      required: true
    },
    containsMultipleSamples: {
      type: Boolean,
      default: false
    },
    category: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      componentId: `species-of-interest-${this.category}-${this.speciesData?.sampleSpeciesUUID}`
    }
  },
  computed: {
    primaryAbundanceValue () {
      return {
        value: this.convertSmallValueToZero(this.speciesData?.abundanceValue)
      }
    },
    secondaryAbundanceValue () {
      return this.containsMultipleSamples
        ? { value: this.convertSmallValueToZero(this.speciesData?.abundanceValueSecondarySample) }
        : { value: null }
    },
    healthyCohortComparisonValue () {
      return this.convertSmallValueToZero(this.speciesData?.average)
    },
    reportData () {
      return Report.query().whereId(Report.lockedId).first() || null
    },
    distributorConfiguration () {
      return this.reportData?.reportConfiguration || null
    },
    distributor () {
      return this.distributorConfiguration?.slug || null
    },
    storagePath () {
      return localStorage.getItem('public_storage') || null
    },
    domainMin () {
      return this.distributorConfiguration?.abundanceMeter?.domainMin || 0.001
    },
    domainMax () {
      return this.distributorConfiguration?.abundanceMeter?.domainMax || 10
    }
  },
  methods: {
    convertSmallValueToZero (abundanceValue) {
      return abundanceValue < abundanceModel.lowerBoundForAbundanceValue ? 0 : abundanceValue
    },
    getHealthIndicatorImageUrl (speciesData) {
      const imageService = new ImageService(this.storagePath, this.distributor, speciesData)
      return imageService.getHealthyIndicatorIcon()
    },
    formattedValue (value) {
      return reportDataService.getFormattedAbundance(value)
    }
  }
}
</script>
